import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CourtCasesQueryVariables = Types.Exact<{
  filters: Types.CourtCasesListFilterInput
  sorts?: Types.InputMaybe<Types.CourtCasesListSortInput>
}>

export type CourtCasesQuery = {
  __typename?: 'Query'
  courtCases: {
    __typename?: 'CourtCasesCollection'
    items: Array<{
      __typename?: 'CourtCase'
      uuid: string
      upcomingAppointment?: any | null
      state: Types.CourtCaseState
      createdAt: any
      messages: {
        __typename?: 'MessagesCollection'
        last?: { __typename?: 'Message'; id: number; type: Types.MessageType } | null
      }
      topic: { __typename?: 'Topic'; id: number; name: string }
      customer: {
        __typename?: 'Customer'
        id: number
        firstName?: string | null
        lastName?: string | null
        membership?: {
          __typename?: 'Membership'
          uuid: string
          membershipType: { __typename?: 'MembershipType'; uid: string; displayName: string }
        } | null
      }
    }>
  }
}

export const CourtCasesDocument = gql`
  query CourtCases($filters: CourtCasesListFilterInput!, $sorts: CourtCasesListSortInput) {
    courtCases(filters: $filters, sorts: $sorts) {
      items {
        uuid
        messages(filters: {}, sorts: { createdAt: ASC }) {
          last {
            id
            type
          }
        }
        topic {
          id
          name
        }
        customer {
          id
          firstName
          lastName
          membership {
            uuid
            membershipType {
              uid
              displayName
            }
          }
        }
        upcomingAppointment
        state
        createdAt
      }
    }
  }
`
export function useCourtCasesQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<CourtCasesQuery, CourtCasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CourtCasesQuery, CourtCasesQueryVariables>(
    CourtCasesDocument,
    options
  )
}
export function useCourtCasesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CourtCasesQuery, CourtCasesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CourtCasesQuery, CourtCasesQueryVariables>(
    CourtCasesDocument,
    options
  )
}
export type CourtCasesQueryHookResult = ReturnType<typeof useCourtCasesQuery>
export type CourtCasesLazyQueryHookResult = ReturnType<typeof useCourtCasesLazyQuery>
export type CourtCasesQueryResult = ApolloReactCommon.QueryResult<
  CourtCasesQuery,
  CourtCasesQueryVariables
>
export function refetchCourtCasesQuery(variables?: CourtCasesQueryVariables) {
  return { query: CourtCasesDocument, variables: variables }
}
